module.exports = __webpack_public_path__ + "img/portrait start.0e4801eb.jpg";